import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  link: {
    textDecoration: "none",
    borderRadius: 8,
    margin: "2px 8px",
    padding: "8px 16px",
    minHeight: 42,
    transition: "background-color .15s ease, color .15s ease",
    "&:hover, &:focus": {
      backgroundColor: "#ececec",
    },
  },
  externalLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    width: "100%",
  },
  linkActive: {
    backgroundColor: "#e6e6e6",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: 3,
      borderRadius: "8px 0 0 8px",
      backgroundColor: "#1a1a1a",
    },
    "&:hover, &:focus": {
      backgroundColor: "#e0e0e0",
    },
  },
  linkNested: {
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 6,
    margin: "1px 12px 1px 0",
    borderRadius: 8,
    "&:hover, &:focus": {
      backgroundColor: "#ececec",
    },
  },
  linkIcon: {
    marginRight: 12,
    minWidth: 0,
    color: "#1a1a1a",
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("color"),
    "& img": { width: 20, height: 20, objectFit: "contain" },
    "& svg": { fontSize: 21 },
  },
  linkIconActive: {
    color: "#1a1a1a",
  },
  linkText: {
    padding: 0,
    color: "#1a1a1a",
    fontSize: 14.5,
    fontWeight: 400,
    letterSpacing: "-0.005em",
    lineHeight: 1.25,
    whiteSpace: "normal",
    transition: theme.transitions.create(["opacity", "color"]),
  },
  linkTextActive: {
    color: "#1a1a1a",
    fontWeight: 500,
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    position: "relative",
    marginLeft: 34,
    paddingLeft: 6,
    marginTop: 2,
    marginBottom: 4,
    borderLeft: "1.5px solid #d6d6d6",
  },
  sectionTitle: {
    marginLeft: 16,
    marginTop: 18,
    marginBottom: 6,
    color: "#2b2b2b",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.5,
    textTransform: "uppercase",
  },
  divider: {
    margin: "10px 16px",
    height: 1,
    backgroundColor: "#dcdcdc",
  },
  expandIcon: {
    color: "#555",
    fontSize: 20,
  },
  nestedDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: "#a8a8a8",
    marginLeft: 4,
    marginRight: 16,
    flexShrink: 0,
    transition: theme.transitions.create("background-color"),
  },
  nestedDotActive: {
    backgroundColor: "#1a1a1a",
  },
  nestedIcon: {
    marginLeft: 2,
    marginRight: 12,
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#1a1a1a",
    "& img": { width: 18, height: 18, objectFit: "contain" },
    "& svg": { fontSize: 19 },
  },
  nestedBullet: {
    fontSize: 9,
    marginLeft: 6,
    marginRight: 17,
    color: "#a8a8a8",
    flexShrink: 0,
    transition: theme.transitions.create("color"),
  },
}));
